var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Icon from "../icon/Icon";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import Box from "../box/Box";
import useResponsiveProp from "../hooks/useResponsiveProp";
var StarRating = function (_a) {
    var rating = _a.rating, _b = _a.color, color = _b === void 0 ? "sunwashGold" : _b, _c = _a.emptyStarColor, emptyStarColor = _c === void 0 ? "black" : _c, size = _a.size, style = _a.style, rest = __rest(_a, ["rating", "color", "emptyStarColor", "size", "style"]);
    if (rating < 0 || rating > 5) {
        console.error('Star rating must be a number between 0 and 5');
        return null;
    }
    var _sizes = useResponsiveProp(size);
    var numStars = parseFloat((Math.round(rating * 2) / 2).toFixed(1));
    var hasHalfStar = numStars - Math.floor(numStars) == 0.5;
    var wholeStars = Array(Math.floor(numStars)).fill(0);
    var emptyStars = Array((5 - wholeStars.length) - (hasHalfStar ? 1 : 0)).fill(0);
    return (React.createElement(Box, __assign({ display: "inline-block" }, rest, { style: __assign({ cursor: rest.onClick ? "pointer" : "initial" }, style) }),
        React.createElement(Box, { display: "grid", gridTemplateColumns: "1", gridTemplateRows: "1" },
            React.createElement(Box, { gridColumn: "1", gridRow: "1", zIndex: 1 }, Array.from(Array(5)).map(function (_, i) { return (React.createElement(Icon, { key: "reg".concat(i), color: emptyStarColor, icon: FaRegStar, size: _sizes, "aria-hidden": "true" })); })),
            React.createElement(Box, { gridColumn: "1", gridRow: "1", zIndex: 2 },
                wholeStars.map(function (_, i) { return (React.createElement(Icon, { key: i, color: color, icon: FaStar, size: _sizes, "aria-hidden": "true" })); }),
                hasHalfStar && (React.createElement(Icon, { color: color, icon: FaStarHalfAlt, size: _sizes, "aria-hidden": "true" }))))));
};
export default StarRating;
//# sourceMappingURL=StarRating.js.map